<template>
    <v-text-field
        class="number-input"
        :value="value"
        type="number"
        outlined
        @change="notifyChange"
        :rules="numberRules"
    >
        <v-icon slot="append" @click="increment"> mdi-plus </v-icon>
        <v-icon slot="prepend-inner" @click="decrement"> mdi-minus </v-icon>
    </v-text-field>
</template>

<script>

export default {
    props: {
        value: [String, Number],
        min: Number,
        max: Number,
        default: Number,
        rules: Array,
    },
    computed: {
        numberRules() {
            const rules = [...this.rules];
            if (this.min) rules.push((v) => v >= this.min || `不能小於${this.min}`);
            if (this.max) rules.push((v) => v <= this.max || `不能大於${this.max}`);
            return rules;
        },
    },
    methods: {
        increment() {
            const newValue = Number.parseInt(this.value, 10) + 1;
            console.log(this.max, newValue);
            if (!this.max || newValue <= this.max) {
                this.$emit('input', newValue);
            }
        },
        decrement() {
            const newValue = Number.parseInt(this.value, 10) - 1;
            if (!this.min || newValue >= this.min) {
                this.$emit('input', newValue);
            }
        },
        notifyChange(e) {
            this.$emit('input', e);
        },
    },
    mounted() {
        if (!this.value) this.$emit('input', this.default);
    },
};
</script>

<style>
.number-input input {
    text-align: center;
}
</style>
